export default "__VITE_ASSET__DzurYoid__"